import { getMembersZendeskHealthcheckUrl } from "@/constants/zendesk-urls/members-healthcheck-urls";
import { membersZendeskSsoLink } from "@/server/models/zendesk/zendesk-sso-link";
import ExternalLinkIcon from "@public/icons/external-link-icon.svg";
import Link from "next/link";

/**
 * 契約形態の説明モーダルコンテンツ
 */
export const ContractTypeHelpDialogContent = ({
  fiscalYear,
}: {
  fiscalYear: number;
}) => {
  const healthCheckInfoUrl = membersZendeskSsoLink(
    getMembersZendeskHealthcheckUrl("健康診断", fiscalYear),
  );

  return (
    <div className="space-y-4 text-sm">
      <div>
        <h3 className="font-bold">■ 直契約健診機関</h3>
        <p className="mt-1 text-monotone-7">
          当組合と健診機関が直接契約している健診機関です。
        </p>
      </div>

      <div>
        <h3 className="font-bold">■ 東振協契約健診機関</h3>
        <p className="mt-1 text-monotone-7">
          <a
            href="https://www.toshinkyo.or.jp/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-6 underline"
          >
            東京都総合組合保健施設振興協会（東振協）
            <ExternalLinkIcon className="ml-1 inline h-3.5 w-3.5 fill-primary-6" />
          </a>
          が契約している健診機関です。東振協が健診機関との契約や取りまとめを行っており、選択できる健診機関が豊富です。
        </p>
      </div>

      <div className="border-t border-monotone-3 pt-4">
        <p className="text-monotone-7">
          契約形態が異なるため、補助の利用方法もそれぞれ異なります。
        </p>
        <p className="mt-2 text-monotone-7">
          詳細は「
          <Link
            href={healthCheckInfoUrl}
            className="text-primary-6 underline"
            prefetch={false}
            target="_blank"
            rel="noopener noreferrer"
          >
            {fiscalYear}年度健康診断のお知らせ（加入者の皆様へ）
          </Link>
          」内の健診機関の補助利用方法をご確認ください。
        </p>
        <p className="mt-2 text-monotone-7">
          なお、各健診機関の単価は、健診コースや対応オプション検査欄に記載しておりますので、あわせてご確認ください。
        </p>
      </div>
    </div>
  );
};
